import React from 'react'
import { RelatedQaSection } from 'components/smartsearch/RelatedQaSection'

const Main = ({ flavour, smartSearchData, query = {} }) => {
  // Always pass an object with foundQa array to RelatedQaSection
  let normalizedSmartSearchData = { foundQa: [] }
  if (smartSearchData) {
    if (typeof smartSearchData === 'object' && Array.isArray(smartSearchData.foundQa)) {
      normalizedSmartSearchData = smartSearchData
    } else if (Array.isArray(smartSearchData)) {
      normalizedSmartSearchData = { foundQa: smartSearchData }
    }
  }

  const selectedAols = query.aol ? [].concat(query.aol) : []

  return (
    <section className='bg-page-background'>
      <div className='layout-width-constraint'>
        <RelatedQaSection {...{ flavour, smartSearchData: normalizedSmartSearchData, selectedAols }} />
      </div>
    </section>
  )
}

export default Main
